<template>
  <div class="right-box">

    <div class="right-box-content">
      <div class="left-list">
        <div class="right-header">
          <!-- <b>{{navName}}</b> -->
          <el-breadcrumb separator-class="el-icon-arrow-right" class="crumbs">
            <el-breadcrumb-item v-for="(item,index) in navStr"
                                :key="item.id"
                                :to="index ===0?'/home/'+(item.system === 4?'contract':'repositories')+'?id='+item.id + '&name='+item.name+'&system=' + navStr[0].system:'/home/list?id='+navStr[0].id+'&cid='+item.id+'&name='+item.name+''">
              {{ item.name }}
            </el-breadcrumb-item>
          </el-breadcrumb>
          <div style="float:right;display: flex;align-items: center;">
            <div style="margin-right: 10px;">
              <el-input placeholder="请输入搜索信息" v-model="keyword" class="input-with-select header-input">
                <el-button slot="append" icon="el-icon-search" @click="toSearch"></el-button>
              </el-input>
            </div>
            <span class="goBtn" @click="prev">返回</span>
          </div>

        </div>
        <el-table
          v-if="tableData.length>0"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="名称" width="300">
            <template slot-scope="scope">
              <span
                class="table-name ovDna"
                @click="toDetail(scope.row.id,scope.row.type,scope.row.label)"
              >

              <i
                class="nameIcon iconfont iconfolder"
                style="color:#f1e531"
                v-if="scope.row.type===2"
              ></i>
              <i
                class="nameIcon iconfont iconfile_word"
                style="color: #2677dc"
                v-else-if="scope.row.type===1 && (scope.row.typeName === 'doc' || scope.row.typeName === 'docx')"
              ></i>
              <i
                class="nameIcon iconfont iconfile_excel"
                style="color: #27e239"
                v-else-if="scope.row.type===1 && (scope.row.typeName === 'xls' || scope.row.typeName === 'xlsx')"
              ></i>
              <i
                class="nameIcon iconfont iconfile_ppt"
                style="color: #e4393c"
                v-else-if="scope.row.type===1 && (scope.row.typeName === 'ppt' || scope.row.typeName === 'pptx')"
              ></i>
              <i
                class="nameIcon iconfont iconfile_pdf"
                style="color: #d50000"
                v-else-if="scope.row.type===1 && scope.row.typeName === 'pdf'"
              ></i>
              <i
                class="nameIcon iconfont iconfile_img"
                style="color: #27e239"
                v-else-if="scope.row.type===1 && (scope.row.typeName === 'jpg' || scope.row.typeName === 'png'|| scope.row.typeName === 'bmp'|| scope.row.typeName === 'gif'|| scope.row.typeName === 'jpeg')"
              ></i>
              <i class="nameIcon iconfont iconfile_zip" style="color: #E23E22" v-else></i>
              {{ scope.row.label }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="lastuname" label="最后修改人"></el-table-column>
          <el-table-column prop="addtime" sortable label="最后修改时间" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" width="260">
            <template slot-scope="scope">
              <div class="flex align-center justify-between">
                 <span
                   class="set-btn"

                   @click="editName(scope.row.id,scope.row.label)"
                 >编辑</span>

                <span class="set-btn" @click="showMode(scope.row.id,1)">移动</span>
                <a class="set-btn" :href="scope.row.filepath" target="_blank">下载</a>
                <span class="set-btn active" @click="DelFolder(scope.row.id)">删除</span>
              </div>

            </template>
          </el-table-column>
        </el-table>
        <el-upload
          v-else
          class="upload-pic"
          :action="domain"
          :data="QiniuData"
          :on-error="uploadError"
          :on-success="uploadSuccess"
          :before-upload="beforeAvatarUpload"
          :show-file-list="false"
          multiple
          drag
          :file-list="fileList"
        >
          <!--          <el-button size="small" type="primary">点击上传图片</el-button>-->
          <div class="up-text">
            <h3>文件夹是空的</h3>
            <p>你可以创建新文档或拖动文件到这里上传</p>
          </div>
        </el-upload>
        <div class="chiose-box" v-if="multipleSelection.length>0">
          已选择{{ multipleSelection.length }}项
          <el-button type="success" @click="showMode('',2)">批量移动</el-button>
          <el-button type="danger" @click="DelFolderAll">批量删除</el-button>
          <el-button @click="closeChiose">取消</el-button>
        </div>
      </div>
      <div class="right-set">
        <rightSet @isAdd="AddItem" @paixu="paixu" :KuName="KuName"></rightSet>
      </div>
    </div>
    <el-dialog
      title="修改文件夹"
      :visible.sync="dialogVisible"
      width="40%"
      :close-on-click-modal="false"
    >
      <div>
        <el-input v-model="nowFolderName" placeholder="请输入文件夹名称"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="noEditWjj">取 消</el-button>
        <el-button type="primary" @click="editWjj">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="选择文件夹"
      :visible.sync="dialogVisible2"
      width="40%"
      :close-on-click-modal="false"
    >
      <div>
        <modeTree @modeSet="modeSet"/>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="noModeWjj">取 消</el-button>
        <el-button type="primary" @click="moveSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import rightSet from "./rightSetList";
import {genUpToken} from "../../tools/CryptoJS";
import modeTree from "../components/modeTree";

export default {
  name: "list",
  data() {
    return {
      keyword: '',
      navStr: [],
      navName: "", //  文件夹导航,
      KuName: "", //  知识库名称,
      tableData: [], //  资源数据
      multipleSelection: [], //  选择的文件
      QiniuData: {
        fname: "", //  文件名
        key: "", //文件名字处理
        token: "" //七牛云token
      },
      domain: "http://upload-z2.qiniup.com/", // 七牛云的上传地址（华南区）
      qiniuaddr: "https://img.emof.cn", // 七牛云的图片外链地址 你的七牛云里配置有
      uploadPicUrl: "", //提交到后台图片地址
      fileList: [],
      nowTime: "",
      fileExtension: "",
      sort: 1, //  1：按目录排序   2：按文件名称正序 3：按文件名称降序 4：按修改人名称正序 5：按修改人名称降序 6：按修改时间正序      7：按修改时间降序      8：按文件类型
      loading: null,
      dialogVisible: false, //  修改文件夹名称
      dialogVisible2: false, //  移动文件夹名称
      nowFolderName: "", //  当前修改的文件夹名称
      nowFolderId: "", //  当前修改/移动的文件夹id
      modeKid: "", //  选择的要移动的库id
      modeId: "" //  选择的要移动的文件夹id
    };
  },
  created() {
    this.kidName = this.$route.query.name;
    this.nowTime = this.getDate();
    var token;
    var policy = {};
    var bucketName = "zhishiguanli"; //你的七牛桶名称
    var AK = "_MhT6BWLiDGy2755HTwoxzNH747ecCtlqldVq3p3"; //你的七牛AK
    var SK = "15juIkGIozY13PvocO4o5lckBFb-OzqFrSVAAM7z"; //你的七牛SK
    var deadline = Math.round(new Date().getTime() / 1000) + 3600;
    policy.scope = bucketName;
    policy.deadline = deadline;
    token = genUpToken(AK, SK, policy);
    this.QiniuData.token = token;
    if (this.$route.query.id) {
      this.getList();
    }
  },
  methods: {
    toSearch() {

      if (!this.keyword) return
      this.$router.push({
        path: '/home/repositoriesSearch/' + this.keyword,
      })
    },
    //  提交批量移动
    moveSubmit() {
      if (this.modeType === 1) {
        this.moveItem();
      } else {
        this.moveSome();
      }
    },
    //  监听移动的库id 和文件夹id
    modeSet(kid, id) {
      this.modeKid = kid;
      this.modeId = id;
    },
    //  批量移动
    moveSome() {
      let _arr = [];
      this.multipleSelection.map(item => {
        _arr.push(item.id);
      });
      let _isNowKu =
        Number(this.modeKid) === Number(this.$route.query.id) ? 1 : 2; //  当前库内移动为1 移出至其他库传2
      this.loading = this.$loading({
        lock: true,
        text: '移动中，请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$api.apiContent
        .Moveku({
          mid: this.$store.state.userMid,
          folderid: this.modeId,
          kid: this.modeKid,
          ids: _arr,
          isnowku: _isNowKu
        })
        .then(res => {
          this.loading.close();
          this.$message.success(res.msg);
          this.getList();
          this.$store.state.upTree = true;
          this.dialogVisible2 = false;
          this.nowFolderName = "";
          this.nowFolderId = "";
          this.modeId = "";
          this.modeKid = "";
          this.closeChiose();
        })
        .catch(e => {
          this.$message.error(e.msg);
        });
    },
    //  单个文件或文件夹移动
    moveItem() {
      this.loading = this.$loading({
        lock: true,
        text: '移动中，请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let _isNowKu =
        Number(this.modeKid) === Number(this.$route.query.id) ? 1 : 2; //  当前库内移动为1 移出至其他库传2
      this.$api.apiContent
        .Moveku({
          mid: this.$store.state.userMid,
          folderid: this.modeId,
          kid: this.modeKid,
          ids: [this.nowFolderId],
          isnowku: _isNowKu
        })
        .then(res => {
          this.loading.close();
          this.$message.success(res.msg);
          this.getList();
          this.$store.state.upTree = true;
          this.dialogVisible2 = false;
          this.nowFolderName = "";
          this.nowFolderId = "";
          this.modeId = "";
          this.modeKid = "";
        })
        .catch(e => {
          this.loading.close();
          this.$message.error(e.msg);
        });
    },
    //  取消文件移动
    noModeWjj() {
      this.dialogVisible2 = false;
      this.nowFolderName = "";
      this.nowFolderId = "";
    },
    //  显示文件移动
    showMode(id, type) {
      this.dialogVisible2 = true;
      if (type === 1) {
        this.nowFolderId = id;
        this.modeType = 1;
      } else {
        this.modeType = 2;
      }
    },
    //  提交编辑文件夹名
    editWjj() {
      this.$api.apiContent
        .EditFolder({
          mid: this.$store.state.userMid,
          title: this.nowFolderName,
          username: this.$store.state.userName,
          id: this.nowFolderId
        })
        .then(res => {
          this.noEditWjj();
          this.$message.success(res.msg);
          this.getList();
          this.$store.state.upTree = true;
        })
        .catch(e => {
          this.$message.error(e.msg);
        });
    },
    //  取消修改
    noEditWjj() {
      this.dialogVisible = false;
      this.nowFolderName = "";
      this.nowFolderId = "";
    },
    //  显示编辑文件夹名
    editName(id, name) {
      this.dialogVisible = true;
      this.nowFolderName = name;
      this.nowFolderId = id;
    },
    //  取消多选
    closeChiose() {
      this.multipleSelection = [];
      this.$refs.multipleTable.clearSelection();
    },
    //  批量删除
    DelFolderAll() {
      this.$confirm("此操作将删除该文件至回收站, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let _arr = [];
          this.multipleSelection.map(item => {
            _arr.push(item.id);
          });
          this.$api.apiContent
            .DelFolder({
              mid: this.$store.state.userMid,
              username: this.$store.state.userName,
              ids: _arr
            })
            .then(res => {
              this.$message.success(res.msg);
              this.getList();
              this.$store.state.upTree = true;
            })
            .catch(e => {
              this.$message.error(e.msg);
            });
        })
        .catch();
    },
    //  单个删除
    DelFolder(id) {
      this.$confirm("此操作将删除该文件至回收站, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$api.apiContent
            .DelFolder({
              mid: this.$store.state.userMid,
              username: this.$store.state.userName,
              ids: [id]
            })
            .then(res => {
              this.$message.success(res.msg);
              this.getList();
              this.$store.state.upTree = true;
            })
            .catch(e => {
              this.$message.error(e.msg);
            });
        })
        .catch();
    },
    //  排序
    paixu(id) {
      this.sort = Number(id);
    },
    //  获取当前文件或文件夹的导航
    NowTab() {
      this.$api.apiContent
        .NowTab({
          mid: this.$store.state.userMid,
          FileId: this.$route.query.cid
        })
        .then(res => {
          this.KuName = res.data[0].name;
          this.navName = "";
          this.navStr = [];
          var data = res.data;
          for (var i = 0; i < data.length; i++) {
            if (data[i].name) {
              this.navStr.push(data[i])
              continue
            }
            this.navStr.push(
              {"name": data[i].label, "id": data[i].id}
            )
          }
          // res.data.map(item => {
          // this.navStr += item.name
          //   ? '<span @click="goUrl()">' + item.name + "</span>" + " > "
          //   : '<span @click="goUrl2()">' + item.label + "</span>" + " > ";
          // });
          // this.navName = this.navName.substring(0, this.navName.length - 2);
          // this.navStr = this.navStr.substring(0, this.navStr.length - 2);
          console.log(this.navStr);
        });
    },
    //  去详情
    toDetail(id, type, name) {
      // 文件或文件夹id  type:1 文件  2：文件夹
      console.log(type);
      if (type === 2) {
        this.$router.push({
          path: "/home/list",
          query: {
            id: this.$route.query.id, //  知识库id
            cid: id,
            name: name //    文件名称
          }
        });
        // this.$store.state.upTree = true;
      } else if (type === 1) {
        this.$router.push({
          path: "/home/detail",
          query: {
            id: this.$route.query.id, //  知识库id
            cid: id,
            name: name //    文件名称
          }
        });
        // this.$store.state.upTree = true;
      }
    },
    //  更新列表
    AddItem() {
      this.getList();
      this.$store.state.upTree = true;
    },
    //  获取当前文件夹资源
    getList() {
      this.NowTab();
      this.$api.apiContent
        .GetOneFolderList({
          mid: this.$store.state.userMid,
          folderid: this.$route.query.cid,
          kid: this.$route.query.id,
          sort: this.sort
        })
        .then(res => {
          if (res.data) {
            res.data.map(item => {
              if (item.type === 1) {
                item.typeName = item.label.split(".").pop();
              }
              item.addtime = this.$tools.ZHDate(
                new Date(item.addtime * 1000),
                1
              );
            });
            this.tableData = res.data;
          }
        })
        .catch(e => {
          console.log(e);
          this.tableData = [];
        });
    },
    //  获取选择数据
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    //  上传前判断
    beforeAvatarUpload(file) {
      //这里的key给加上了时间戳，目的是为了防止上传冲突
      this.QiniuData.fname = file.name;
      this.QiniuData.key = `${this.nowTime}${file.name}`;
      console.log(this.QiniuData.key);
      this.loading = this.$loading({
        lock: true,
        text: "上传中，请稍后",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    //  上传成功
    uploadSuccess(response, file, fileList) {
      console.log(file);
      console.log(fileList);
      this.uploadPicUrl = `${this.qiniuaddr}/${response.key}`;
      console.log(this.uploadPicUrl);
      //在这里你就可以获取到上传到七牛的外链URL了
      this.$api.apiContent
        .addFile({
          mid: this.$store.state.userMid,
          folderid: this.$route.query.cid,
          label: file.name,
          filesize: file.size,
          kid: this.$route.query.id,
          savename: response.key,
          username: this.$store.state.userName,
          filetype: file.name.split(".").pop()
        })
        .then(() => {
          this.loading.close();
          this.$message.success("上传成功");
          this.getList();
        })
        .catch(e => {
          this.$message.error(e.msg);
        });
    },
    //  上传失败
    uploadError(err, file, fileList) {
      console.log(err);
      console.log(file);
      console.log(fileList);
      this.loading.close();
      this.$message({
        message: "上传出错，请重试！",
        type: "error",
        center: true
      });
    },

    //以下是时间戳函数
    getDate() {
      var myDate = new Date();
      //获取当前年
      var year = myDate.getFullYear();
      //获取当前月
      var month = myDate.getMonth() + 1;
      //获取当前日
      var date = myDate.getDate();
      var h = myDate.getHours(); //获取当前小时数(0-23)
      var m = myDate.getMinutes(); //获取当前分钟数(0-59)
      var s = myDate.getSeconds();
      //获取当前时间
      var now =
        year +
        this.conver(month) +
        this.conver(date) +
        this.conver(h) +
        this.conver(m) +
        this.conver(s) +
        "_";
      return now;
    },
    conver(s) {
      return s < 10 ? "0" + s : s;
    },
    prev() {
      this.$router.go(-1);
      this.$store.state.upTree = true;
    },
    setName() {
      this.kidName = this.$route.query.name;
      this.getList();
    }
  },
  watch: {
    $route: "setName",
    sort() {
      this.getList();
    }
  },
  components: {
    rightSet,
    modeTree
  }
};
</script>

<style scoped lang="scss">
.goBtn {
  height: 42px;
  line-height: 42px;
  width: 60px;
  text-align: center;
  border-radius: 6px;
  cursor: pointer;
  background: #0a2240;
  color: #ffffff;
}

.crumbs {
  font-size: 18px;
}

.right-box {
  .right-header {
    height: 60px;
    line-height: 60px;
    border-bottom: 1px solid #ddd;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    b {
      font-size: 18px;
      padding-right: 5px;
    }
  }

  .right-box-content {
    display: flex;

    .left-list {
      flex: 1;

      .nameIcon {
        font-size: 24px;
        position: relative;
        top: 2px;
      }

      .table-name {
        font-size: 16px;
        font-weight: bold;

        &:hover {
          color: #0a2240;
          cursor: pointer;
        }
      }

      .set-btn {
        display: block;
        cursor: pointer;
        width: 50px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        background-color: #0a2240;
        border-radius: 15px;
        color: #fff;

        &.active {
          background: #fff;
          border: 1px solid #0a2240;
          color: #0a2240;
        }
      }

      .upload-pic {
        padding: 100px 0;
      }

      .up-text {
        padding: 50px;

        h3 {
          font-size: 24px;
          text-align: center;
          line-height: 60px;
          color: #666;
        }

        p {
          line-height: 40px;
          color: #999;
        }
      }

      .chiose-box {
        position: fixed;
        display: flex;
        align-items: center;
        justify-content: space-around;
        left: 350px;
        bottom: 50px;
        width: 480px;
        height: 60px;
        padding: 15px;
        border-radius: 10px;
        background: #fff;
        border: 1px solid #ddd;
        box-shadow: 10px 10px 10px #ddd;
      }
    }

    .right-set {
      width: 250px;
      padding: 25px;
      height: calc(100vh - 100px);
      background: #edf2f7;
    }
  }
}
</style>
